import { useSelector } from 'react-redux'

export default (id, type) => {
  const componentFromState = useSelector(
    ({ [`${type}ModuleComponents`]: components }) => components[id],
  )

  return componentFromState
}
